//@flow

export const storeDataInLocalStorage = (key: string, value: string) => window.localStorage.setItem(key, value);
export const getDataInLocalStorage = (key: string) => window.localStorage.getItem(key);
export const removeDataInLocalStorage = (key: string) => window.localStorage.removeItem(key);